<template>
<!-- 批量添加用户 -->
  <div class="el-card pd20">
    <!-- 搜索---serch-box -->
    <div class="box">
      <!--  -->
      <div class="search">
        <!--  -->
        <div class="search-gropu on">
          <el-button style="margin-left:10px;" type="primary" @click="recharge" size="medium">充值</el-button>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="search-box"></div>
      <!-- list -->
      <div class="list-box">
        <el-table :data="list"  show-overflow-tooltip border style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column type="index" width="55" label="序号"></el-table-column>
          <!-- <el-table-column prop="product_id" label="产品ID" width="65"></el-table-column> -->
          <el-table-column prop="name" label="购买测评"></el-table-column>
          <el-table-column prop="sum" label="购买总数"></el-table-column>
          <el-table-column prop="used" label="已使用数"></el-table-column>
          <el-table-column prop="valid" label="未使用数"></el-table-column>
          <el-table-column prop="invalid" label="已失效数"></el-table-column>
          <el-table-column width="120px"  label="操作">
              <template  slot-scope="scope">
                  <el-button type="primary" size="mini"  @click="usedRecords(scope.$index, scope.row)" >使用记录</el-button>
              </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
    
  </div>
</template>

<script>
import { buyList} from "@/api/consultant";
import { deepCopy } from "@u/tools";
export default {
    data() {
        return{
          list: [],
          buyList:[],
          formLabelWidth: '120px'
        }
    },
    methods:{
      // 充值
      recharge(){
        this.$router.push({
          path:'/main/consultant_purchased_form',
          query:{
            id:this.$route.query.id,
          }
        });
      },
      // 使用记录
      usedRecords(index,row){
        this.$router.push({
          path:'/main/consultant_usage_record',
          query:{
            id:this.$route.query.id,
            product_id:row.product_id,
          }
        });
      },
      // 初始化获取数据
      pullData(){
          if(!this.$route.query.id){
            this.$message('获取购买记录失败，ID为空！');
            return
          }
          this.$showLoading();
          buyList({
            id:this.$route.query.id
          }).then((data)=>{
            this.$hideLoading();
            if(data.error>0){
              this.$message(data.msg);
              return
            }
            this.list = data.list;
          }).catch((err)=>{
            this.$hideLoading();
          });

      }
    },
    created(){
        this.pullData();
    }
    
}
</script>

<style lang="scss" scoped>
.main{
  position: relative;
}
.addBtn{
  position: absolute;
  left: 0;
  bottom: 0;
}
.addBtn.on{
  position: absolute;
  left: 30px;
  bottom: 0;
}
.pages{
  text-align: right;
  margin-top: 30px;
}
.box {
  margin-bottom: 20px;
}
.search {
  display: flex;
  margin-bottom: 20px;
}

.search.search-btn {
  flex: 1;
}

.search-gropu {
  flex: 1;
}
.search-gropu.on{
    flex:1.5;
}

.search-child {
  margin-left: 20px;
  width: 150px;
  margin-right: 40px;
}
.btn-group{
    text-align:right;
}
</style>
